import React from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';

import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Collapse from '@mui/material/Collapse';

import { ReportGridItem } from '@/components/reports/types/report';

import { ReportContent } from './reportContent';
import { ReportHeading } from './reportHeading';
import { UseFiltersResponse } from '../../hooks/useFilters';

export const ReportAccordionWithPreview = ({
  clearFilters,
  group,
}: {
  clearFilters: UseFiltersResponse['clearFilters'];
  group: {
    description: string;
    items: ReportGridItem[];
    title: string;
  };
}) => {
  const [expanded, setExpanded] = React.useState(true);

  return (
    <Card
      sx={{
        bgcolor: 'transparent',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        position: 'relative',
      }}
    >
      <Collapse collapsedSize={300} in={expanded}>
        <AccordionSummary
          aria-controls={group.title}
          expandIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          id={group.title}
          onClick={() => setExpanded(!expanded)}
        >
          <ReportHeading description={group.description} title={group.title} />
        </AccordionSummary>
        <AccordionDetails>
          <ReportContent key={group.title} clearFilters={clearFilters} items={group.items} />
        </AccordionDetails>
      </Collapse>
      {!expanded && (
        <Box
          sx={{
            background: 'linear-gradient(0deg, #0E1320 0%, rgba(14, 19, 32, 0.00) 100%)',
            bottom: 0,
            height: '217px',
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            zIndex: 1,
          }}
        />
      )}
    </Card>
  );
};
